import Vue from 'vue';
import Vuex from 'vuex';
import http_client from "../services/http_client";
import { errorMessage } from "../services/messges";
import social from './social.json';
import meeting_errors from "./meeting_errors";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        after_login: false,
        loaded_page: true,
        reasons: [],
        reasons_loaded: false,
        loading: false,
        isLogged: (_ => {
            return !!localStorage.getItem('jwt')
        })(),
        loginChecked: null,
        user: null,
        user_info: null,
        tags: [],
        meeting_error_text: null,
        current_event: null,
        redirect_to_events: false,
        languages: [],
        professions: [],
        interests: [],
        current_is_draft: false,
        nearestMeetingsInfo: [],
        last_nearest_meeting_load_time: null,
        refresh_nearest_info_interval: 43200000, // 12 * 60 * 60 * 1000 milliseconds
        refresh_event_status: {
            id: 0, is_reserved: false
        },
        tmp_token: null
    },
    mutations: {
        set_tmp_token(state, value) {
            state.tmp_token = value;
        },
        set_after_login(state, value) {
            state.after_login = !!value;
        },
        set_meeting_error(state, type = null) {
            if (type in meeting_errors) {
                state.meeting_error_text = meeting_errors[type];
            } else {
                state.meeting_error_text = null;
            }
        },
        set_is_loaded_page(state, value) {
            state.loaded_page = !!value;
            state.loading = !value;
        },
        set_reasons(state, value) {
            state.reasons = value;
        },
        set_reasons_loaded(state, value) {
            state.reasons_loaded = !!value;
        },
        set_refresh_event_status(state, value) {
            state.refresh_event_status = value;
        },
        set_last_nearest_meeting_load_time(state, value) {
            state.last_nearest_meeting_load_time = value;
        },
        setNearestMeetingsInfo(state, value) {
            state.nearestMeetingsInfo = value;
        },
        setCurrentIsDraft(state, value) {
            state.current_is_draft = !!value;
        },
        setProfessions(state, value) {
            state.professions = value;
        },
        setInterests(state, value) {
            state.interests = value;
        },
        setLanguages(state, value) {
            state.languages = value;
        },
        setRedirectToEvents(state, value) {
            state.redirect_to_events = !!value;
        },
        setCurrentEvent(state, value) {
            state.current_event = value;
        },
        setCurrentUser(state, value) {
            state.current_user = value;
        },
        setLoginChecked(state, value) {
            state.loginChecked = value;
        },
        setLoading(state, value = false) {
            // if (!state.loaded_page && !value) {
            //     return;
            // }
            state.loading = !!value;
        },
        setLogged(state, value) {
            state.isLogged = !!value;
        },
        async login(state, data = null) {
            if (data) {
                const user = data.user || null;
                const jwt = data.token || null;
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('jwt', jwt);
                if (!(user && jwt)) {
                    return;
                }
            }
            state.isLogged = true;
            state.loginChecked = true;
        },
        setTags(state, value) {
            state.tags = value;
        },
        setUserInfo(state, value) {
            state.user_info = value;
            localStorage.setItem('user', JSON.stringify(value));
        }
    },
    getters: {
        get_tmp_token(state) {
            return state.tmp_token;
        },
        is_after_login(state) {
            return state.after_login;
        },
        get_meeting_error_text(state) {
            return state.meeting_error_text;
        },
        is_loaded_page(state) {
            return state.loaded_page;
        },
        get_reasons(state) {
            return state.reasons;
        },
        get_refresh_event_status(state) {
            return state.refresh_event_status;
        },
        get_last_nearest_meeting_load_time(state) {
            return state.last_nearest_meeting_load_time;
        },
        isCurrentDraft(state) {
            return state.current_is_draft;
        },
        getSocial() {
            return social;
        },
        getUserInfo(state) {
            return state.user_info;
        },
        getProfessions(state) {
            return state.professions;
        },
        getInterests(state) {
            return state.interests;
        },
        getLanguages(state) {
            return state.languages;
        },
        isRedirectToEvents(state) {
            return state.redirect_to_events;
        },
        getCurrentEvent(state) {
            return state.current_event;
        },
        getCurrentUser(state) {
            return state.current_user;
        },
        isLogged(state) {
            return state.isLogged;
        },
        isLoading(state) {
            return state.loading;
        },
        getTags(state) {
            return state.tags;
        },
        isLoginChecked(state) {
            return state.loginChecked;
        },
        getNearestMeetingsInfo(state) {
            return state.nearestMeetingsInfo;
        }
    },
    actions: {
        async loadCurrentEvent({commit, state}, event_id) {
            if (!state.current_event || !state.current_event.id || +state.current_event.id !== +event_id) {
                commit('setLoading', true);
                try {
                    const response = await http_client.getAuth(`${http_client.apiUrl()}users/events/${event_id}/details`);
                    if (response && response.data && response.data.data && response.data.data.id && +response.data.data.id === +event_id) {
                        commit('setCurrentEvent', response.data.data || null);
                        commit('setCurrentIsDraft', response?.data?.data?.is_draft || false);
                    }
                } catch (e) {
                    errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
                    commit('setRedirectToEvents', true);
                }
                commit('setLoading', false);
            }
        },
        async loadUserInfo({commit, state}) {
            try {
                const response = await http_client.postAuth(`${http_client.apiUrl()}users/user/info`);
                commit('setUserInfo', response.data.data.user || {})
            } catch (e) {
                errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
            } finally {
                commit('setLoading', false);
            }
        },
        async loadReasons({commit, state}) {
            if (state.reasons_loaded) {
                return;
            }
            try {
                const response = await http_client.getAuth(`${http_client.apiUrl()}users/complains/reasons`);
                commit('set_reasons', response?.data?.data?.list || {})
                commit('set_reasons_loaded', true)
            } catch (e) {
                errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
            }
            commit('setLoading', false);
        },
        async loadTags({commit, state}) {
            if (!state.tags.length) {
                commit('setLoading', true);
                try {
                    const response = await http_client.getAuth(`${http_client.apiUrl()}tags`);
                    if (response && response.data && response.data.data && response.data.data.tags) {
                        commit('setTags', response.data.data.tags || []);
                    }
                } catch (e) {
                    errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
                }
                commit('setLoading', false);
            }
        },
        async loadNearestMeetingsInfo({commit, state}, is_forse = false) {
            const saved_meeting_info = state.last_nearest_meeting_load_time;
            if (
                state.isLogged &&
                (
                    !saved_meeting_info
                    || ((Date.now() - saved_meeting_info) > state.refresh_nearest_info_interval)
                    || is_forse)
            ) {
                commit('setLoading', true);
                try {
                    const response = await http_client.getAuth(`${http_client.apiUrl()}users/events/nearest`);
                    if (response && response.data && response.data.data && response.data.data.list) {
                        commit('setNearestMeetingsInfo', response.data.data.list || []);
                        commit('set_last_nearest_meeting_load_time', Date.now());
                    }
                } catch (e) {
                    errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
                } finally {
                    commit('setLoading', false);
                }
            }
        },
        async loadAutocompleteData({commit, state}) {
            if (!state.languages.length || !state.interests.length || state.professions.length) {
                commit('setLoading', true);
                try {
                    const response = await http_client.get(`${http_client.apiUrl()}autocomplete-data`);
                    if (response && response.data && response.data.success && response.data.data && response.data.data.languages) {
                        commit('setLanguages', response.data.data.languages || []);
                        commit('setProfessions', response.data.data.professions || []);
                        commit('setInterests', response.data.data.interests || []);
                    }
                } catch (e) {
                    errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
                }
                commit('setLoading', false);
            }
        }
    },
    modules: {}
})
